<script lang="ts" module>
    import { getContext, setContext } from "svelte";
    import { CommunicationRegistry, type fnCallback } from "./ComTypes";
    import { ErrorForbidden, ErrorNoAuth, ErrorServerInternal, ErrorUserInput } from "../gen/adprovisioning";
    export function setService<T>(key: string | Symbol, service: T): T {
        setContext(key, service);
        return service;
    }

    export function getService<T>(key: string | Symbol): () => T {
        return () => getContext(key) as T;
    }

    export function defineService<T>(
        key: string | Symbol = Symbol()
    ): [() => T, (service: T) => T] {
        return [
            getService<T>(key),
            (service: T) => {
                setService(key, service);
                return service;
            },
        ];
    }

    export enum MESSAGE_TYPE {
        SUCCESS = 'SUCCESS',
        INFO = 'INFO',
        WARNING = 'WANRING',
        ERROR = 'ERROR'
    };

    export interface MessagingService {
        BoradcastMessage(message: string, type: MESSAGE_TYPE),
        BroadCastError(error: Error | string): void;
        RegisterCommunicationRegistry(
            topic: string,
            reg: CommunicationRegistry
        );
        UnRegisterCommunicationRegistry(topic: string);
        Subscribe(topic: string, caller: Object, fn: fnCallback): boolean;
        UnSubscribe(topic: string, caller: Object, fn: fnCallback): boolean;
    }

    export enum SERVICES {
        Messaging = "Messsaging",
    }

    let messagingServiceInstance: MessagingService = undefined;
    export function setMessagingService(msgSrv: MessagingService) {
        setService(SERVICES.Messaging, msgSrv);
        messagingServiceInstance = msgSrv;
    }

    export function getMessagingService(): MessagingService {
        return getContext<MessagingService>(SERVICES.Messaging);
    }


    /**
     * A default error handler for any api call
     * @param err
     */
    export function DefaultErrorHandler(err: string | Error | ErrorForbidden | ErrorNoAuth | ErrorUserInput | ErrorServerInternal) {
        if(!messagingServiceInstance) {
            console.error("Messaging service not set");
        }

        let errText: string;
        if(err instanceof Error) {
            errText = err.message;
        }

        if(err instanceof ErrorForbidden) {
            messagingServiceInstance.BroadCastError("Access forbidden! " + errText);
            return;
        } else if(err instanceof ErrorNoAuth) {
            messagingServiceInstance.BroadCastError("You are not authenticated, please log in. " + errText);
            // TODO redirect to login
            return;
        } else if(err instanceof ErrorUserInput) {
            messagingServiceInstance.BroadCastError("Bad Input. Please check your input " + errText);
            return;
        } else if(err instanceof ErrorServerInternal) {
            messagingServiceInstance.BroadCastError("Internal server error, please try again later. " + errText);
            return;
        }
        messagingServiceInstance.BroadCastError(err);
    }
</script>
